import { ReactNode } from 'react'
import { ReactComponent as BookingIcon } from 'src/assets/svg/booking-brand.svg'
import { ReactComponent as ExpediaIcon } from 'src/assets/svg/expedia-brand.svg'
import { ReactComponent as FacebookIcon } from 'src/assets/svg/facebook.svg'
import { ReactComponent as InstagramIcon } from 'src/assets/svg/instagram.svg'
import { ReactComponent as LinkedInIcon } from 'src/assets/svg/linkedin.svg'
import { ReactComponent as XIcon } from 'src/assets/svg/x.svg'
import { ReactComponent as WhatsappIcon } from 'src/assets/svg/whatsapp.svg'
import classes from './pageCard.module.scss'

const PLATFORM_LABELS: Record<string, string> = {
  booking: 'Booking.com',
  expedia: 'Expedia',
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  twitter: 'X (Twitter)',
  whatsapp: 'WhatsApp',
}

export const getPlatformLabel = (platform: string) =>
  PLATFORM_LABELS[platform] ??
  platform.charAt(0).toUpperCase() + platform.slice(1)

export const getPlatformIcon = (platform: string): ReactNode => {
  switch (platform) {
    case 'facebook':
      return <FacebookIcon className={classes.socialIcon} />
    case 'instagram':
      return <InstagramIcon className={classes.socialIcon} />
    case 'twitter':
      return <XIcon className={classes.socialIcon} />
    case 'linkedin':
      return <LinkedInIcon className={classes.socialIcon} />
    case 'whatsapp':
      return <WhatsappIcon className={classes.socialIcon} />
    case 'booking':
      return (
        <BookingIcon
          className={`${classes.brandIcon} ${classes.bookingCardIcon}`}
        />
      )
    case 'expedia':
      return <ExpediaIcon className={classes.brandIcon} />
    default:
      return null
  }
}
